var _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _g5, _g6, _g7, _g8, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect4, _path35, _path36, _rect5, _rect6, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingAprove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410.36,
    height: 344.757,
    viewBox: "0 0 410.36 344.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839",
    transform: "translate(-745.891 -151.241)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6915",
    "data-name": "Path 6915",
    d: "M1908.647,1728.532s-4.395-63.5-43.892-84.979-87.729-6.674-105.413,25.965-39.351,138.405-107.014,139.12-141.482,20.063-151.051,65.753,34.941,120.877,258.065,100.372C1901.812,1963.143,1916.849,1789.88,1908.647,1728.532Z",
    transform: "translate(-754.191 -1482.233)",
    fill: "#e1e7ed"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756",
    transform: "translate(1072.404 202.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6916",
    "data-name": "Path 6916",
    d: "M1767.187,1860.608s-29.272-7.14-27.362-24.316,10.725-21.5,13.635-30.791-18.906-23.048-13.725-39.4,21.577-20.746,23.242-26.82-6.861-18.165-9.915-26.438,7.76-37.228,22.716-41.045,16.226,13.365,12.727,28.635,7.318,21.534,13.682,39.72-1.274,33.778-3.184,41.416,11.774,11.769,16.865,27.361-.956,35.317-23.547,55.363S1767.187,1860.608,1767.187,1860.608Z",
    transform: "translate(-1738.935 -1671.26)",
    fill: "#24dcae"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765",
    transform: "translate(1079.84 220.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757",
    transform: "translate(21.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6917",
    "data-name": "Path 6917",
    d: "M1764.468,1861.914c-.015-.276-1.357-27.9,6.2-46.216,4.276-10.366-.343-16.21-4.809-21.861-3.349-4.239-6.515-8.24-5.719-13.807.819-5.721,3.572-10.366,6.235-14.857,3.367-5.676,6.545-11.037,5.994-18.324-.722-9.512-3.729-16.166-6.385-22.04-1.078-2.384-2.1-4.638-2.923-6.962-2.984-8.382,1.162-27.273,5.349-33.913l.872.548c-3.992,6.328-8.093,25.034-5.253,33.022.813,2.281,1.822,4.517,2.891,6.879,2.693,5.952,5.742,12.7,6.477,22.389.573,7.61-2.838,13.364-6.138,18.926-2.611,4.4-5.31,8.96-6.1,14.477-.733,5.129,2.3,8.962,5.508,13.024,4.435,5.61,9.461,11.968,4.953,22.891-7.466,18.1-6.136,45.5-6.121,45.772Z",
    transform: "translate(-1760.013 -1683.934)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758",
    transform: "translate(18.444 2.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6918",
    "data-name": "Path 6918",
    d: "M1764.8,1697.127l-6.938-10.787.866-.557,6.458,10.043,12.441-5.531.418.941Z",
    transform: "translate(-1757.867 -1685.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759",
    transform: "translate(8.672 19.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6919",
    "data-name": "Path 6919",
    d: "M1766.435,1711.229l-15.717-12.08.629-.816,15.141,11.638,12.856-8.2.553.866Z",
    transform: "translate(-1750.718 -1698.333)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760",
    transform: "translate(19.824 48.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6920",
    "data-name": "Path 6920",
    d: "M1772.815,1730.2l-13.939-9.326.574-.854,13.349,8.931,13.542-9.56.594.841Z",
    transform: "translate(-1758.877 -1719.387)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761",
    transform: "translate(10.784 67.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    d: "M1767.947,1750.517,1752.263,1734l.746-.71,15.284,16.1,25.609-5.514.218,1.007Z",
    transform: "translate(-1752.263 -1733.288)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762",
    transform: "translate(1.953 99.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6922",
    "data-name": "Path 6922",
    d: "M1770.212,1766.515l-.171-.055-24.238-7.779.314-.981,24.066,7.725,23.45-8.967.368.961Z",
    transform: "translate(-1745.803 -1756.459)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6763",
    "data-name": "Group 6763",
    transform: "translate(8.625 124.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6923",
    "data-name": "Path 6923",
    d: "M1770.737,1795.664l-20.053-19.6.718-.737,19.533,19.094,34.344-16.837.453.925Z",
    transform: "translate(-1750.684 -1775.324)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764",
    transform: "translate(0 152.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6924",
    "data-name": "Path 6924",
    d: "M1770.543,1815.308l-26.168-18.8.6-.836,25.711,18.471,26.449-10.57.382.956Z",
    transform: "translate(-1744.375 -1795.672)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6925",
    "data-name": "Path 6925",
    d: "M1753.665,1749.294c3.195-10.078-.26-28.051,5.379-32.238,12.553,0,10.294,16.513,9.754,18.531-2.853,10.683,5.964,15.062,11.151,27.783s-1.038,23.629-2.594,28.97,9.595,8.235,13.744,19.14c3.479,9.144.571,20.322-11.309,31.958-5.687-1.639-27.7-8.985-26.035-23.954,1.91-17.175,10.727-21.5,13.636-30.791S1748.486,1765.645,1753.665,1749.294Z",
    transform: "translate(-661.416 -1451.557)",
    fill: "#47e2cc",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768",
    transform: "translate(1066.984 265.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6926",
    "data-name": "Path 6926",
    d: "M1754.525,1847.826s-20.262-4.943-18.94-16.835,7.424-14.88,9.441-21.316-13.089-15.954-9.5-27.273,14.937-14.362,16.088-18.566-4.749-12.576-6.862-18.3,5.372-25.772,15.725-28.415,11.234,9.252,8.811,19.823,5.066,14.909,9.472,27.5-.882,23.383-2.205,28.668,8.151,8.15,11.675,18.943-.663,24.449-16.3,38.326S1754.525,1847.826,1754.525,1847.826Z",
    transform: "translate(-1734.97 -1716.747)",
    fill: "#02bb8d"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6777",
    "data-name": "Group 6777",
    transform: "translate(1071.406 271.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769",
    transform: "translate(16.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6927",
    "data-name": "Path 6927",
    d: "M1753.34,1848.139c-.011-.2-.967-19.878,4.42-32.935,3.009-7.293-.249-11.416-3.4-15.4-2.4-3.039-4.671-5.911-4.1-9.93.587-4.1,2.552-7.416,4.455-10.624,2.381-4.016,4.63-7.81,4.24-12.944-.51-6.74-2.644-11.461-4.528-15.627-.77-1.7-1.494-3.3-2.083-4.961-2.135-6,.827-19.507,3.818-24.252l.872.547c-2.824,4.481-5.727,17.714-3.721,23.36.575,1.617,1.294,3.2,2.053,4.883,1.918,4.243,4.093,9.052,4.617,15.972.414,5.457-2.026,9.57-4.384,13.547-1.85,3.119-3.763,6.347-4.32,10.244-.511,3.583,1.625,6.287,3.887,9.146,3.178,4.023,6.783,8.581,3.543,16.43-5.3,12.842-4.353,32.3-4.342,32.491Z",
    transform: "translate(-1750.172 -1721.465)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770",
    transform: "translate(14.296 1.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6928",
    "data-name": "Path 6928",
    d: "M1753.668,1731.116l-5-7.78.868-.557,4.524,7.037,8.731-3.882.418.94Z",
    transform: "translate(-1748.663 -1722.779)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771",
    transform: "translate(7.392 14.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6929",
    "data-name": "Path 6929",
    d: "M1754.914,1741.071l-11.3-8.271.607-.832,10.646,7.792,8.535-7.253.667.784Z",
    transform: "translate(-1743.612 -1731.968)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772",
    transform: "translate(13.773 34.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6930",
    "data-name": "Path 6930",
    d: "M1759.837,1754.636l-11.557-7.122.541-.877,10.979,6.767,9.56-6.75.593.839Z",
    transform: "translate(-1748.28 -1746.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6773",
    "data-name": "Group 6773",
    transform: "translate(6.863 49.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6931",
    "data-name": "Path 6931",
    d: "M1756.486,1768.7l-13.26-10.377.634-.809,12.881,10.079,18.178-3.914.218,1.007Z",
    transform: "translate(-1743.225 -1757.518)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774",
    transform: "translate(0 69.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6932",
    "data-name": "Path 6932",
    d: "M1761.591,1784.7l-23.386-11.708.46-.923,22.771,11.4,10.506-9.141.677.774Z",
    transform: "translate(-1738.205 -1772.069)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6775",
    "data-name": "Group 6775",
    transform: "translate(7.334 88.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6933",
    "data-name": "Path 6933",
    d: "M1757.908,1801.2l-14.338-14.015.72-.737,13.817,13.506,24.333-11.928.453.925Z",
    transform: "translate(-1743.57 -1786.446)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6776",
    "data-name": "Group 6776",
    transform: "translate(1.216 108.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6934",
    "data-name": "Path 6934",
    d: "M1757.775,1815.163l-18.68-13.421.6-.834,18.22,13.09,18.736-7.488.382.956Z",
    transform: "translate(-1739.094 -1800.908)",
    fill: "#fff"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6935",
    "data-name": "Path 6935",
    d: "M1813.82,1808.075h-95.1s2.951,60.845,20.859,60.845h50.789C1813.147,1868.92,1813.82,1808.075,1813.82,1808.075Z",
    transform: "translate(-673.951 -1418.152)",
    fill: "#3b55eb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6936",
    "data-name": "Path 6936",
    d: "M1746.875,1808.075h-28.156s2.951,60.845,20.859,60.845h28.155C1749.824,1868.92,1746.875,1808.075,1746.875,1808.075Z",
    transform: "translate(-673.951 -1418.152)",
    fill: "#536dfe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6937",
    "data-name": "Path 6937",
    d: "M1710.47,1868.956c0,3.381-37.529,6.119-83.825,6.119s-83.824-2.738-83.824-6.119,37.529-15.978,83.824-15.978S1710.47,1865.575,1710.47,1868.956Z",
    transform: "translate(-738.506 -1401.671)",
    fill: "#bbc6d1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6938",
    "data-name": "Path 6938",
    d: "M1705.757,1862.364c-11.446,2.385-42.534,4.094-79.112,4.094s-67.665-1.709-79.11-4.094c-3.04,1.32-4.714,2.437-4.714,3.147,0,3.381,37.529,6.119,83.824,6.119s83.825-2.738,83.825-6.119C1710.47,1864.8,1708.8,1863.685,1705.757,1862.364Z",
    transform: "translate(-738.506 -1398.227)",
    fill: "#758ca1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6939",
    "data-name": "Path 6939",
    d: "M1657.135,1793.369a12.385,12.385,0,0,0,12.386,12.387h40.8a12.385,12.385,0,0,0,12.385-12.387h0a12.382,12.382,0,0,0-12.385-12.384h-40.8a12.382,12.382,0,0,0-12.386,12.384Z",
    transform: "translate(-696.551 -1428.094)",
    fill: "#a4b7ca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3960",
    "data-name": "Rectangle 3960",
    width: 7.649,
    height: 79.343,
    transform: "translate(989.545 375.767)",
    fill: "#a4b7ca"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3961",
    "data-name": "Rectangle 3961",
    width: 18.961,
    height: 31.04,
    transform: "translate(983.889 392.158)",
    fill: "#a4b7ca"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3962",
    "data-name": "Rectangle 3962",
    width: 11.804,
    height: 9.836,
    transform: "translate(987.469 384.291)",
    fill: "#a4b7ca"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6940",
    "data-name": "Path 6940",
    d: "M1676.386,1855.8a6.469,6.469,0,1,0,6.469-6.469A6.471,6.471,0,0,0,1676.386,1855.8Z",
    transform: "translate(-689.486 -1403.01)",
    fill: "#a4b7ca"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785",
    transform: "translate(1035.52 441.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6941",
    "data-name": "Path 6941",
    d: "M1711.951,1852.476a6.627,6.627,0,1,0,6.627-6.626A6.627,6.627,0,0,0,1711.951,1852.476Z",
    transform: "translate(-1711.951 -1845.85)",
    fill: "#a4b7ca"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786",
    transform: "translate(992.627 417.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6942",
    "data-name": "Path 6942",
    d: "M1727.47,1853.415h5.247v-9.326c0-6.812-24.027-15.479-52.067-15.883l-.075,5.247c27.659.4,44.655,8.307,46.9,11.072Z",
    transform: "translate(-1680.575 -1828.206)",
    fill: "#a4b7ca"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6788",
    "data-name": "Group 6788",
    transform: "translate(937.967 441.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6943",
    "data-name": "Path 6943",
    d: "M1653.844,1852.476a6.627,6.627,0,1,1-6.628-6.626A6.628,6.628,0,0,1,1653.844,1852.476Z",
    transform: "translate(-1640.59 -1845.85)",
    fill: "#a4b7ca"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6789",
    "data-name": "Group 6789",
    transform: "translate(941.971 417.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6944",
    "data-name": "Path 6944",
    d: "M1643.519,1853.415h5.245v-8.891c2.239-2.764,19.235-10.674,46.9-11.072l-.075-5.247c-28.04.4-52.065,9.072-52.065,15.883Z",
    transform: "translate(-1643.519 -1828.206)",
    fill: "#a4b7ca"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6945",
    "data-name": "Path 6945",
    d: "M1759.717,1659.13s9.836-1.311,13.443-.437,10.741,5.5,11.833,13.144-1.938,117.729-5.437,139.878-16.738,20.352-95.643,20.851c-79.562-2.915-67.483-4.431-68.65-7.636s-1.219-15.431,1.512-16.309c10.275,3.61,114.419-2.4,114.419-2.4Z",
    transform: "translate(-712.197 -1473.087)",
    fill: "#758ca1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6946",
    "data-name": "Path 6946",
    d: "M1766.836,1815.472s9.62-136.391,6.121-156.5c-21.859-2.851-65.793-.874-74.753,3.278s-13.991,44.153-13.991,52.242-5.247,32.058-9.91,41.82-9.324,39.49-7.357,52.167c-36.5,0-49.479.062-51.886.062,8.527,8.527,45.986,11.741,86.422,11.087S1766.836,1815.472,1766.836,1815.472Z",
    transform: "translate(-711.994 -1473.366)",
    fill: "#bbc6d1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6947",
    "data-name": "Path 6947",
    d: "M1766.836,1774.973s-45.158-1.325-99.889-6.994c-36.5,0-49.479.062-51.886.062,8.527,8.527,45.986,11.741,86.422,11.086S1766.836,1774.973,1766.836,1774.973Z",
    transform: "translate(-711.994 -1432.867)",
    fill: "#cad5e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6948",
    "data-name": "Path 6948",
    d: "M1697.422,1733.312s-70.295,35.98-76.383,40.684-5.2,15.274-4.1,35.2c.9,16.24,1.661,59.707,2.027,76.654.083,3.844-9.036,7.534-9.036,7.534l20,1.248s5.106-37.954,7.648-53.822.964-39.473,1.334-43.9S1717.9,1757.3,1717.9,1757.3Z",
    transform: "translate(-713.877 -1445.591)",
    fill: "#fdb6b0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6949",
    "data-name": "Path 6949",
    d: "M1637.481,1796.908c.369-4.425,78.986-39.611,78.986-39.611l-20.479-23.986s-70.295,35.98-76.383,40.684-6.365,13.559-5.258,33.485c.623,11.189,1.286,35.907,1.751,55.428a24.7,24.7,0,0,0,17.037,2.231c1.531-9.143,3.107-18.634,4.12-24.945C1639.793,1824.328,1637.111,1801.337,1637.481,1796.908Z",
    transform: "translate(-712.441 -1445.591)",
    fill: "#3b55eb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6950",
    "data-name": "Path 6950",
    d: "M1641.011,1806.395c.425.919,3,3.6,3.429,4.531,7.849,17.04,14.476,39.469,19.141,52.763,2.078,5.921-4.83,9.05-4.83,9.05l22.04,5.949s-10.113-48.139-15.864-72.293Z",
    transform: "translate(-702.471 -1418.768)",
    fill: "#fdb6b0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6951",
    "data-name": "Path 6951",
    d: "M1724.83,1736.541l-30.136-1.01s-64.944,35.436-67.432,44.291,8.854,30.718,20.2,55.35c4.715,10.231,9.759,23.036,14.05,34.52,5.791,1.531,11.513-1.691,16.683-4.349-2.277-12.073-4.882-25.019-7.214-34.577-5.812-23.8-15.771-38.491-15.771-38.491s44.558,2.216,65.867-10.239S1724.83,1736.541,1724.83,1736.541Z",
    transform: "translate(-707.645 -1444.776)",
    fill: "#536dfe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6952",
    "data-name": "Path 6952",
    d: "M1666.185,1719.07s-18.358-12.322-13.823-39.811c2.886-17.509,2.842-34.568,9.163-33.1,4.682-8.182,17.475-14.976,29.6-11.048s17.244,16.546,23.908,31.888,19.048,27.668,12.59,46.843-10.97,23.912-23.776,31.876C1695.159,1741.9,1666.185,1719.07,1666.185,1719.07Z",
    transform: "translate(-698.568 -1482.054)",
    fill: "#4d677e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6953",
    "data-name": "Path 6953",
    d: "M1670.64,1664.436c0,5.025-3.147,9.095-7.026,9.095s-7.023-4.069-7.023-9.095,3.143-9.091,7.023-9.091S1670.64,1659.416,1670.64,1664.436Z",
    transform: "translate(-696.75 -1474.206)",
    fill: "#bbc6d1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6954",
    "data-name": "Path 6954",
    d: "M1670.031,1664.269c0-3.839-1.843-7.114-4.441-8.447-.105-.007-.211-.022-.319-.022-3.877,0-7.022,4.072-7.022,9.092,0,3.84,1.838,7.117,4.439,8.449.107.007.209.022.317.022C1666.884,1673.363,1670.031,1669.294,1670.031,1664.269Z",
    transform: "translate(-696.143 -1474.039)",
    fill: "#dde4eb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6955",
    "data-name": "Path 6955",
    d: "M1687.838,1688.005l-16.351,41.751s-53.689,5.535-60.885,6.641-8.854,5.813-8.854,5.813h70.017c6.365,0,8.856-4.152,11.624-10.794s15.219-39.575,15.219-39.575Z",
    transform: "translate(-716.881 -1462.219)",
    fill: "#fdb6b0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M1665.691,1687.022l-6.769,14.861a57,57,0,0,1,12.194,5.193c3.431-9,6.509-17.136,6.509-17.136Z",
    transform: "translate(-695.896 -1462.58)",
    fill: "#f75267"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    d: "M1679.685,1676.493s-12.742,8.064-14.944,15.4c-1.642,5.465-4.705,20.481-4.152,25.738s16.605,25.459,15.36,40.127c15.36,3.876,36.948,1.385,36.948,1.385s5.945-39.236,8.086-60.482c1.711-17-26.909-22.173-34.1-22.173Z",
    transform: "translate(-695.309 -1466.444)",
    fill: "#ff6a75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6958",
    "data-name": "Path 6958",
    d: "M1680.261,1852.547c-4.869,6.339-13.524,5.653-19.645,1.383-.9.73-2.839,1.906-3.782,2.5-3.736,2.351-13.006,3.182-15.5,3.182s-2.63,7.195-2.63,7.195h45.11S1684.5,1857.285,1680.261,1852.547Z",
    transform: "translate(-703.316 -1401.83)",
    fill: "#536dfe"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6959",
    "data-name": "Path 6959",
    d: "M1635.9,1847.4c-5.363,5.223-10.868,5.312-16.571,1.594-4.277,2.864-12.818,3.636-16.972,3.978-4.521.37-8.026,5.443-5.535,7.932h41.441S1637.853,1850.665,1635.9,1847.4Z",
    transform: "translate(-718.992 -1403.72)",
    fill: "#3b55eb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6960",
    "data-name": "Path 6960",
    d: "M1671.71,1675.49s.969,6.917,1.106,11.207,8.857,8.441,12.732-.693c-.14-8.716,0-23.384,0-23.384Z",
    transform: "translate(-691.203 -1471.536)",
    fill: "#f9a9a5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6961",
    "data-name": "Path 6961",
    d: "M1658.714,1652.11s-5.378,25.157,14.314,34.245c4.623,1.281,16.593-4.824,19.16-16.174s1.749-21.532-5.681-25.119-27.627,6.328-27.627,6.328",
    transform: "translate(-696.219 -1478.267)",
    fill: "#fdb6b0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6962",
    "data-name": "Path 6962",
    d: "M1665.762,1669.165s7.077-.015,8.693-.517C1671.48,1673.245,1669.223,1674.265,1665.762,1669.165Z",
    transform: "translate(-693.387 -1469.323)",
    fill: "#fff4f3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6963",
    "data-name": "Path 6963",
    d: "M1666.139,1675.284c-7.053-.868-6.324-8.183-6.313-8.251l1.352,1.017c-.026.227-.563,5.184,5.125,5.885Z",
    transform: "translate(-695.574 -1469.916)",
    fill: "#dde4eb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M1670.494,1673.274c0,1.438-1.572,2.606-3.512,2.606s-3.513-1.167-3.513-2.606,1.573-2.606,3.513-2.606S1670.494,1671.836,1670.494,1673.274Z",
    transform: "translate(-694.227 -1468.581)",
    fill: "#dde4eb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M1656.591,1654.254s7.025,5.39,27.157,2.348c15.379,10.342,6.94,21.954,10.294,32.432,10.285-10.362,6.9-38.011-2.1-44.908S1664.468,1638.246,1656.591,1654.254Z",
    transform: "translate(-696.752 -1479.808)",
    fill: "#4d677e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M1694.2,1661.51s-1.5-13.5-10.255-18.311a24.912,24.912,0,0,0-24.631.651,8.266,8.266,0,0,0-1.655,2.636s10.422-4.193,18.809-1.7,12.069,10.461,14.22,18.279c2.606,4.419,5.5-1.553,5.5-1.553",
    transform: "translate(-696.359 -1479.749)",
    fill: "#dde4eb"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6967",
    "data-name": "Path 6967",
    d: "M1693.508,1662.282c0,5.022-3.145,9.092-7.026,9.092s-7.022-4.07-7.022-9.092,3.146-9.094,7.022-9.094S1693.508,1657.261,1693.508,1662.282Z",
    transform: "translate(-688.359 -1474.997)",
    fill: "#bbc6d1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6968",
    "data-name": "Path 6968",
    d: "M1692.9,1662.115c0-3.84-1.841-7.115-4.44-8.449-.107-.007-.211-.021-.319-.021a5.542,5.542,0,0,0-1.132.116c-3.34.7-5.891,4.454-5.891,8.976,0,3.84,1.84,7.117,4.437,8.448.107.007.21.022.317.022C1689.753,1671.207,1692.9,1667.137,1692.9,1662.115Z",
    transform: "translate(-687.75 -1474.83)",
    fill: "#dde4eb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6969",
    "data-name": "Path 6969",
    d: "M1707.392,1688.045l-32.139,31.266s-10.687,8.828-4.892,11.456,10.859,0,16.125-4.9,25.648-23.148,25.648-23.148Z",
    transform: "translate(-692.33 -1462.204)",
    fill: "#fdb6b0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6970",
    "data-name": "Path 6970",
    d: "M1686.73,1699.243s11.931-11.941,15.524-12.9,9.11-1.072,9.11,6.3-14.209,18.954-14.209,18.954S1693.23,1707.458,1686.73,1699.243Z",
    transform: "translate(-685.691 -1463.001)",
    fill: "#ff7888"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6971",
    "data-name": "Path 6971",
    d: "M1680.059,1729.477s9.894-38.779,13.937-46.59c6.119-11.821,1.188-20.222-.616-22.948s-1.881,1.718-1.329,2.983c-.37-1.033-1.114-3.851-2.113-3.564a1.666,1.666,0,0,0-.934,1.806c.2,1.239,1.17,3.586,1.083,4.229-.191-.3-1.129-2.511-1.784-2.209-1.3.595-.6,3.1-.454,3.59s1.459,3.9,1.035,5.462c-.764-2.377-2.256-3.7-3.444-3.516s-1.017,1.538.026,1.978a2.742,2.742,0,0,1,1.319,3.29c-.454,1.341-2.659,5.484-1.814,8.514-1.839,5.275-13.033,26.951-15.975,37.8s-3.759,20.94,4.585,21.934C1679.188,1741.5,1680.059,1729.477,1680.059,1729.477Z",
    transform: "translate(-692.957 -1472.838)",
    fill: "#fdb6b0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3963",
    "data-name": "Rectangle 3963",
    width: 79.546,
    height: 4.548,
    transform: "translate(866.766 279.301)",
    fill: "#3b55eb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    d: "M1642.5,1743.747H1558.8l-19.336-48.059.793-1.36h83.695Z",
    transform: "translate(-739.738 -1459.898)",
    fill: "#3b55eb"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6973",
    "data-name": "Path 6973",
    d: "M1641.136,1743.382h-83.695l-17.974-48.059h83.695Z",
    transform: "translate(-739.738 -1459.533)",
    fill: "#536dfe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3964",
    "data-name": "Rectangle 3964",
    width: 14.367,
    height: 169.514,
    transform: "translate(880.955 288.819)",
    fill: "#758ca1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3965",
    "data-name": "Rectangle 3965",
    width: 229.42,
    height: 6.906,
    transform: "translate(773.43 283.849)",
    fill: "#bbc6d1"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5554",
    "data-name": "Group 5554",
    transform: "translate(841.197 256.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6851",
    "data-name": "Path 6851",
    d: "M3.537.16h0A4.666,4.666,0,0,0,.767,1.192,4.608,4.608,0,0,0,.059,1.9L5.28,5.5a1.023,1.023,0,0,1,.318.356,1.009,1.009,0,0,1,.12.46l.02.575a4.488,4.488,0,0,1-.224,1.56,4.51,4.51,0,0,1-.312.725,4.533,4.533,0,0,1-.438.665l1.944,1.336a1.141,1.141,0,0,0,.584.2,1.145,1.145,0,0,0,.6-.135,1.127,1.127,0,0,0,.441-.426,1.107,1.107,0,0,0,.15-.591l-.2-5.682a4.5,4.5,0,0,0-.856-2.492A4.56,4.56,0,0,0,6.115.831,4.626,4.626,0,0,0,3.537.16Z",
    transform: "translate(3.689 0.17)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6852",
    "data-name": "Path 6852",
    d: "M2.818,5.311,2.8,4.736a4.5,4.5,0,0,1,.534-2.289,4.541,4.541,0,0,1,.438-.667L1.82.453a1.132,1.132,0,0,0-1.44.1,1.108,1.108,0,0,0-.306.524,1.1,1.1,0,0,0-.034.309l.21,5.687a4.492,4.492,0,0,0,.86,2.489,4.561,4.561,0,0,0,1.318,1.211A4.627,4.627,0,0,0,5,11.445H5a4.7,4.7,0,0,0,2.764-1.03,4.637,4.637,0,0,0,.709-.708L3.257,6.121a1.054,1.054,0,0,1-.314-.355,1.041,1.041,0,0,1-.125-.455Z",
    transform: "translate(0 0.294)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6853",
    "data-name": "Path 6853",
    d: "M6.738,4.6a1.071,1.071,0,0,0-.127-.457A1.084,1.084,0,0,0,6.3,3.785L1.078.192a4.516,4.516,0,0,0-.93,2.163,4.492,4.492,0,0,0-.042.794l.021.577a1.072,1.072,0,0,0,.127.457,1.086,1.086,0,0,0,.312.359L5.785,8.128a4.521,4.521,0,0,0,.75-1.39,4.488,4.488,0,0,0,.224-1.56Z",
    transform: "translate(2.669 1.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6854",
    "data-name": "Path 6854",
    d: "M2.427.16A4.618,4.618,0,0,0,.024.93a4.564,4.564,0,0,1,.931.7,4.528,4.528,0,0,1,.711.9,4.492,4.492,0,0,1,.463,1.042,4.467,4.467,0,0,1,.185,1.141l.2,5.682q0,.027,0,.054t0,.053q0,.027-.005.053t-.008.053q.209-.022.416-.061t.408-.1q.2-.056.4-.129t.387-.162l1.472,1.012a1.139,1.139,0,0,0,.584.2,1.146,1.146,0,0,0,.606-.131,1.129,1.129,0,0,0,.446-.426,1.108,1.108,0,0,0,.152-.594L7.174,4.538a4.48,4.48,0,0,0-.406-1.725A4.521,4.521,0,0,0,5.723,1.374,4.583,4.583,0,0,0,4.2.442,4.628,4.628,0,0,0,2.427.16Z",
    transform: "translate(9.653)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingAprove);
export default __webpack_public_path__ + "static/media/waiting-aprove.8230355f.svg";
export { ForwardRef as ReactComponent };